import { getMessageForError } from './../utils/getMessageForError';
import axios, { AxiosError } from 'axios';
import { create } from '@/composables/useNotifications';
import {
    isSessionAuthError,
    markSessionExpired,
} from '@/composables/useEditorSession';

axios.interceptors.response.use(
    (response) => {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    },
    (error: AxiosError) => {
        if (error.response?.status === 422) {
            return Promise.reject(error);
        }

        // Editor-tagged requests (save + heartbeat) handle their own auth
        // failures via the session banner. We must not show the generic toast
        // or let getMessageForError() redirect to login, which would mask the
        // lost session and strand unsaved work.
        const isEditorRequest = Boolean(error.config?.headers?.['X-Editor']);
        if (isEditorRequest && isSessionAuthError(error.response?.status)) {
            markSessionExpired();

            return Promise.reject(error);
        }

        // The background heartbeat must stay silent on non-auth failures
        // (e.g. 403 from an expired trial, 500, or offline) so it doesn't
        // toast an error on every poll.
        if (error.config?.headers?.['X-Heartbeat']) {
            return Promise.reject(error);
        }

        create({
            title: 'An error has occurred.',
            text: getMessageForError(error),
            type: 'error',
            persistent: false,
        });

        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        return Promise.reject(error);
    }
);
